module.exports = __webpack_public_path__ + "images/icon_wallet_4172218d144a51e7312287d0fa379943.svg";